import React from 'react';
import MenuItem from 'material-ui/MenuItem';
import OptionsDropdown from 'components/shared/OptionsDropdown';

export const InspectionsDropdown = ({ data, openDocumentPortal }) => {
  const openDocumentOrUrl = doc => {
    if (doc) {
      if (typeof doc === 'object') {
        // recover unsigned document
        openDocumentPortal(doc);
      } else if (typeof doc === 'string') {
        // open pdf document in new tab
        window.open(doc, '_blank');
      }
    }
  };

  const documentText = (url, value) => {
    if (!url) return `Document Is Being Generated`;

    return `View Inspection`;
  };

  const inspectionText = data.inspection_type === 'Unit Inspection' ? '' : 'Move-In';

  return (
    <OptionsDropdown>
      <MenuItem
        primaryText={documentText(data.move_in_document_url, inspectionText)}
        style={{ fontSize: '14px' }}
        onClick={() => openDocumentOrUrl(data.move_in_document_url)}
      />
      {data.move_out_document_url && (
        <MenuItem
          primaryText={documentText(data.move_in_document_url, 'Move-Out')}
          style={{ fontSize: '14px' }}
          onClick={() => openDocumentOrUrl(data.move_out_document_url)}
        />
      )}
    </OptionsDropdown>
  );
};

export function renderStatus(status) {
  const color = status === 'Complete' ? '#57d500' : '#ffe400';
  return (
    <span>
      <span style={{ color }}>&#x25cf;</span> {status}
    </span>
  );
}

export function getFilterText(e, state) {
  const text = e.target.value ? e.target.value : '';
  state.setState({ filterText: text });
}
